import DateFunc from '@/lib/lyg/date_func';
import DeskUseDataFunc from "@/pcomponents/common/content/edu/desk/func/desku_func";
import StudentCardListArea from "./stu_card_list";

function RoomRowArea(props: any) {
  let myProps = {
    room_info: null,
    Style: {},
    student_info_arr: [],
    set_student_info_arr: (inData: any) => { },
    now_ymdhis: "",
    pre_date_str: "",
    cardview_sort: "",
    select_desku_seq_arr: [],
    set_select_desku_seq_arr: (inData: any) => { },
    open_view_room_popup: (inData: any) => { },
    show_detail_view: (inData: any) => { },
    open_view_desk_popup: (inData: any) => { },
    openTodoDaySort: (inData: any) => { },
    openTodoWriteOnePopup: (inData: any) => { },
    go_change_todo_state_by_ajax: (inData: any) => { },
    openTodoDailyCWritePopup: (inData: any) => { },
    go_todo_dailyc_write: (inData: any) => { },
    ...props
  };
  let Style = myProps.Style;
  let room_info = myProps.room_info;
  let now_date_json = DateFunc.get_date_json(new Date(myProps.now_ymdhis));
  let now_sec = now_date_json.date_obj.getTime() / 1000;
  let desk_ico_100 = process.env.REACT_APP_API_URL + "/img/mobile/ico/desk_white_ico.png";

  let desk_arr: any = [];
  if (room_info.desk_arr) {
    desk_arr = room_info.desk_arr;
  }
  let desku_arr: any = [];
  if (room_info.desku_arr) {
    desku_arr = room_info.desku_arr;
  }
  let now_desku_arr: any = DeskUseDataFunc.get_now_desku_arr({
    now_ymdhis: myProps.now_ymdhis,
    desku_arr: desku_arr,
  });

  const on_check_group_checkbox = (inData: any) => {
    let opt_obj = {
      room_seq: "",
      is_check: false,
      ...inData
    };
    let room_seq = opt_obj.room_seq;
    let is_check = opt_obj.is_check;
    if (is_check) {
      let change_select_desku_seq_arr: any = [];
      for (let i = 0; i < now_desku_arr.length; i++) {
        let tmp_desku_info = now_desku_arr[i];
        let tmp_pri_val = tmp_desku_info["a_ymd"] + "," + tmp_desku_info["a_seq"];
        change_select_desku_seq_arr.push(tmp_pri_val);
      }
      myProps.set_select_desku_seq_arr(change_select_desku_seq_arr);
    } else {
      myProps.set_select_desku_seq_arr([]);
    }
  };

  const get_desk_cnt_str=()=>{
    let desk_arr_len = desk_arr.length;
    let now_desku_arr_len = now_desku_arr.length;
    let desk_cnt_str="";
    if (desk_arr_len > 0) {
      let now_u_cnt_color = "gray";
      if (now_desku_arr_len > 0) {
        now_u_cnt_color = "green";
      }
      if (now_desku_arr_len >= desk_arr_len) {
        now_u_cnt_color = "red";
      }

      desk_cnt_str=now_desku_arr_len+"/"+desk_arr_len;
    }
    return desk_cnt_str;
  };

  const get_room_name_str = () => {
    let room_name_str: any = room_info.a_name;
    return room_name_str;
  };

  return (
    <div className="mt-2">
      <div style={{ position: "relative" }}>
        <label>
          <input type="checkbox" value=""
            onChange={(e: any) => {
              on_check_group_checkbox({
                room_seq: room_info.a_seq,
                is_check: e.target.checked,
              });
            }} />
        </label>
        <button className="btn-l btn-sky ml-1"
          onClick={(e: any) => {
            myProps.open_view_room_popup({
              room_seq: room_info.a_seq,
            });
          }}>
            {get_room_name_str()} 
            <img src={desk_ico_100} style={{height:"20px",marginLeft:"5px"}} />
            <span className="ml-1">({get_desk_cnt_str()})</span>
          </button>
      </div>
      <div>
        <StudentCardListArea
          room_info={room_info}
          student_info_arr={myProps.student_info_arr}
          set_student_info_arr={myProps.set_student_info_arr}
          now_desku_arr={now_desku_arr}
          now_ymdhis={myProps.now_ymdhis}
          pre_date_str={myProps.pre_date_str}
          cardview_sort={myProps.cardview_sort}
          select_desku_seq_arr={myProps.select_desku_seq_arr}
          set_select_desku_seq_arr={myProps.set_select_desku_seq_arr}
          Style={Style}
          show_detail_view={myProps.show_detail_view}
          open_view_desk_popup={myProps.open_view_desk_popup}
          openTodoDaySort={myProps.openTodoDaySort}
          openTodoWriteOnePopup={myProps.openTodoWriteOnePopup}
          go_change_todo_state_by_ajax={myProps.go_change_todo_state_by_ajax}
          openTodoDailyCWritePopup={myProps.openTodoDailyCWritePopup}
          go_todo_dailyc_write={myProps.go_todo_dailyc_write}
        ></StudentCardListArea>
      </div>
    </div>
  );
};
export default RoomRowArea;